import React from 'react';
import { GenesysDevIcon, GenesysDevIcons } from 'genesys-dev-icons';

import { CardClickAction, WrapWithLink } from '../Card';
import MarkdownDisplay from '../../markdown/display/MarkdownDisplay';
import { ContentIndexPage } from '../../../helpers/Sitemap';

import './IconCard.scss';

interface IProps {
	data: ContentIndexPage;
	icon: GenesysDevIcons;
	iconFormat?: 'small' | 'large';
	onClickAction?: CardClickAction;
}

export default function IconCard(props: IProps) {
	let titleContainerClasses = ['dx-card-title-container'];
	let bodyContainerClasses = ['dx-card-body'];
	if (props.iconFormat === 'small') {
		titleContainerClasses.push('icon');
		bodyContainerClasses.push('icon');
	} else {
		titleContainerClasses.push('large-icon');
		bodyContainerClasses.push('large-icon');
	}

	return WrapWithLink(
		<div className="dx-card-icon">
			<div className={titleContainerClasses.join(' ')}>
				<GenesysDevIcon icon={props.icon} />
				<div className="dx-card-title">
					<span className="dx-card-title-text" title={props.data.title || 'Card Title'}>
						{props.data.title || 'Card Title'}
					</span>
				</div>
				<div className="clearfix"></div>
			</div>
			<div className={bodyContainerClasses.join(' ')}>
				<div className="dx-card-body-text">{props.data.teaser ? <MarkdownDisplay markdown={props.data.teaser} /> : undefined}</div>
			</div>
		</div>,
		props.data.link,
		props.onClickAction
	);
}
